import { render, staticRenderFns } from "./SysFreteAutocomplete.vue?vue&type=template&id=4cdda865"
import script from "./SysFreteAutocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./SysFreteAutocomplete.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports